import React, {useMemo, useState} from 'react'
import {Box, Button, Container, TextField, Typography} from '@mui/material'
import styles from './styles'
import _ from 'lodash'
import {useRouteMatch} from 'react-router'
import {useDispatch, useSelector} from 'react-redux'
import {actions as userActions} from '../../redux/modules/users'
import {RootState} from 'redux/rootReducer'
import AlertMessage from '../../components/AlertMessage'

const ResetPasswordPage: React.FC = () => {
  const [password, setPassword] = useState('')
  const [passwordConfirm, setPasswordConfirm] = useState('')
  const [formError, setFormError] = useState<string | undefined>()
  const params = useRouteMatch<{userId: string; resetPasswordToken: string}>()
  const {userId, resetPasswordToken} = params.params
  let userError = useSelector(({users}: RootState) => users.error)
  const dispatch = useDispatch()

  const resetPassword = () => {
    if (_.isEmpty(password) || _.isEmpty(passwordConfirm)) {
      setFormError('All fields are required.')
      return
    }
    if (password === passwordConfirm) {
      dispatch(userActions.resetPassword({userId, resetPasswordToken, password}))
      if (!userError) {
        setPassword('')
        setPasswordConfirm('')
        setFormError('')
      }
      userError = undefined
    } else {
      setFormError('Passwords do not match.')
      userError = undefined
    }
  }
  const errorMessage = useMemo(() => {
    if (formError) {
      return formError
    }

    if (userError) {
      return userError
    }

    return undefined
  }, [formError, userError])

  return (
    <Container component="main" sx={styles.root}>
      <Box sx={styles.form} textAlign="center">
        <Typography sx={styles.headerLabel} variant="h5">
          Please choose a new password
        </Typography>

        <AlertMessage error={errorMessage} severity="error" sx={{marginBottom: 2, width: 300}} />

        <TextField
          sx={styles.textField}
          onChange={e => setPassword(e.target.value)}
          placeholder="Password"
          type="password"
          onKeyDown={args => args.key === 'Enter' && resetPassword()}
        />
        <TextField
          sx={styles.textField}
          onChange={e => setPasswordConfirm(e.target.value)}
          placeholder="Confirm password"
          type="password"
          onKeyDown={args => args.key === 'Enter' && resetPassword()}
        />
        <Button variant="contained" sx={styles.submitButton} onClick={resetPassword}>
          Submit
        </Button>
      </Box>
    </Container>
  )
}
export default ResetPasswordPage
